import { SpaceVertical } from "../../../common/utils/spacing";
import "./formation.css";

export const FormationMobile = () => {
  return (
    <div className="m-formation m-page">
      <h1 className="title"> FORMATION </h1>
      <SpaceVertical size={35} />

      <div className="m-formation-content">
        <OneFormation
          date="Juillet 2017"
          title="BACCALAURÉAT"
          school="Lycée Cherif Samsidine Aidara"
          site="Vélingara, Sénégal"
        />
        <SpaceVertical size={130} />

        <OneFormation
          date="Nov. 2017 - Juin 2020"
          title="LICENCE EN INFORMATIQUE"
          school="UCAO SAINT MICHEL"
          site="Dakar, Sénégal"
        />

        <SpaceVertical size={130} />

        <OneFormation
          date="Sep. 2021 - Fevrier 2022"
          title="FORMATION EN DEV. WEB/MOBILE"
          school="3FPT"
          site="Dakar, Sénégal"
        />
      </div>
    </div>
  );
};

const OneFormation = ({ date, title, school, site }) => {
  return (
    <div className="m-one-formation">
      <div className="block-header">
        <h1>{date}</h1>
      </div>
      <SpaceVertical size={35} />
      <div className="block-deco">
        <div className="vertical"></div>
        <div className="line"></div>
        <div className="horizontal"></div>
      </div>
      <SpaceVertical size={43} />

      <div className="block-footer">
        <h1>{title}</h1>
        <h2>{school}</h2>
        <p>{site}</p>
      </div>
    </div>
  );
};
